import { useDispatch } from 'react-redux'
import { feedbackMessagesToastShow } from '../actions/feedback-messages-actions'
import { type ToastMessage } from '@axilon-apps/libs-ui-types'
import { ToastMessageType } from '@axilon-apps/libs-ui-constants'

type Params = Omit<ToastMessage, 'type'>

//NOTE: only works within the a react-redux context, so ensure that the top level component is wrapped in a store provider
const useToastMessage = () => {
  const dispatch = useDispatch()

  const success = (params: Params) =>
    dispatch(feedbackMessagesToastShow({ type: ToastMessageType.Success, ...params }))
  const info = (params: Params) =>
    dispatch(feedbackMessagesToastShow({ type: ToastMessageType.Info, ...params }))
  const error = (params: Params) =>
    dispatch(feedbackMessagesToastShow({ type: ToastMessageType.Error, ...params }))
  const warning = (params: Params) =>
    dispatch(feedbackMessagesToastShow({ type: ToastMessageType.Warning, ...params }))
  const plain = (params: Params) =>
    dispatch(feedbackMessagesToastShow({ type: ToastMessageType.Plain, ...params }))

  return {
    success,
    info,
    error,
    warning,
    plain
  }
}

export default useToastMessage
